/* global ENV */

import { BrowserClient } from "@sentry/browser";
import React from "react";
import * as configService from "../services/configService";
import CONSTANTS from "../constants";
import styles from "./index.css";
import errorIcon from "./errorIcon.svg";

// Initializing custom sentry client in order to send only custom exceptions to sentry

// eslint-disable-next-line import/no-mutable-exports
export let sentryClient;

export function getSentryClient() {
  if (sentryClient) return sentryClient;

  sentryClient = new BrowserClient({
    dsn: configService.getConfig().SENTRY_DSN,
    environment: ENV,
    enabled: configService.getConfig().SENTRY_ENABLED,
    beforeSend: (event) => {
      event.tags = event.tags || {};
      event.tags.app = CONSTANTS.APP_NAME;
      return event;
    },
  });

  return sentryClient;
}

export const withSentryErrorCapture = (func) => {
  return (...args) => {
    try {
      return func(...args);
    } catch (err) {
      console.error(err);
      getSentryClient().captureException(err);
    }
  };
};

export function ErrorFallback() {
  return (
    <div role='alert' className={styles.errorBoundary}>
      <div className={styles.errorBoundary.iconContainer}>
        <img alt='Error Icon' src={errorIcon} />
      </div>
      <div className={styles.errorBoundary.iconContainer}>
        <p>Something went wrong !</p>
        <p>Please try again later.</p>
      </div>
    </div>
  );
}
